import _implicitStylesheets from "./confirmationFlow.css";
import _implicitScopedStylesheets from "./confirmationFlow.scoped.css?scoped=true";
import _aceSpinner from "ace/spinner";
import _aceListingSummaryCard from "ace/listingSummaryCard";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="header-max-width${0}"${2}><img class="image${0}"${"a1:src"}${"a1:alt"}${2}><h2 type-style="display-6"${3}>${"t3"}</h2></div>`;
const $fragment2 = parseFragment`<img class="confirm-image${0}"${"a0:src"}${"a0:alt"}${2}>`;
const $fragment3 = parseFragment`<h3 type-style="display-5" class="confirm-title${0}"${2}>${"t1"}</h3>`;
const $fragment4 = parseFragment`<span class="confirm-subtitle${0}" type-style="body-3"${2}>${"t1"}</span>`;
const $fragment5 = parseFragment`<span type-style="body-3"${3}>${"t1"}</span>`;
const stc0 = {
  classMap: {
    "container": true
  },
  key: 3
};
const stc1 = {
  classMap: {
    "loading-spinner": true
  },
  key: 4
};
const stc2 = {
  key: 5
};
const stc3 = {
  classMap: {
    "left-column": true
  },
  key: 6
};
const stc4 = {
  attrs: {
    "name": "left-column"
  },
  key: 7
};
const stc5 = [];
const stc6 = {
  classMap: {
    "confirm-column": true
  },
  key: 8
};
const stc7 = {
  classMap: {
    "confirm-copy-container": true
  },
  key: 11
};
const stc8 = {
  attrs: {
    "name": "confirmation-details"
  },
  key: 14
};
const stc9 = {
  attrs: {
    "name": "confirmation-cta"
  },
  key: 19
};
const stc10 = {
  classMap: {
    "right-column": true
  },
  key: 20
};
const stc11 = {
  key: 21
};
const stc12 = {
  attrs: {
    "name": "right-column"
  },
  key: 22
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element, c: api_custom_element, s: api_slot} = $api;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.headerClass),
    key: 0
  }, [!$cmp.confirming ? api_static_fragment($fragment1, 2, [api_static_part(1, {
    attrs: {
      "src": $cmp.headerImgSrc,
      "alt": $cmp.headerImgAltText
    }
  }, null), api_static_part(3, null, api_dynamic_text($cmp.title))]) : null]), api_element("div", stc0, [$cmp.loading ? api_element("div", stc1, [api_custom_element("ace-spinner", _aceSpinner, stc2)]) : null, !$cmp.loading ? !$cmp.confirming ? api_element("div", stc3, [api_slot("left-column", stc4, stc5, $slotset)]) : null : null, !$cmp.loading ? $cmp.confirming ? api_element("div", stc6, [api_static_fragment($fragment2, 10, [api_static_part(0, {
    attrs: {
      "src": $cmp.confirmationImgSrc,
      "alt": $cmp.confirmationImgAltText
    }
  }, null)]), api_element("div", stc7, [api_static_fragment($fragment3, 13, [api_static_part(1, null, api_dynamic_text($cmp.confirmationTitle))]), api_slot("confirmation-details", stc8, stc5, $slotset), $cmp.confirmationSubtitle ? api_static_fragment($fragment4, 16, [api_static_part(1, null, api_dynamic_text($cmp.confirmationSubtitle))]) : null, api_static_fragment($fragment5, 18, [api_static_part(1, null, api_dynamic_text($cmp.confirmationDescription))]), api_slot("confirmation-cta", stc9, stc5, $slotset)])]) : null : null, !$cmp.loading ? api_element("div", stc10, [$cmp.showListingSummaryCard ? api_custom_element("ace-listing-summary-card", _aceListingSummaryCard, stc11) : null, api_slot("right-column", stc12, stc5, $slotset)]) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["confirmation-cta", "confirmation-details", "left-column", "right-column"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3sakduuger3";
tmpl.legacyStylesheetToken = "undefined-_confirmationFlow";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
